// import { createCellPos } from './translateNumToLetter'
import axios from 'axios'
const Excel = require('exceljs')
const XLSX = require('xlsx');
import FileSaver from 'file-saver'
import { axiosBase } from '@/api/api'
const luckysheet = window.luckysheet // 表格实例
// 日期格式
const dateFormat = ['yyyy-MM-dd', 'yyyy-MM-dd HH:mm', 'yyyy-MM-dd hh:mm', 'yyyy-MM-dd HH:mm:ss', 'yyyy-MM-dd ww', 'yyyy-MM', 'HH:mm']
let errorNum = 0

export const exportSheetExcel = function (luckysheetData, fileName, isDown = false) {
  return new Promise(resolve => {
    // 参数为luckysheet.getluckysheetfile()获取的对象
    // 1.创建工作簿，可以为工作簿添加属性
    const workbook = new Excel.Workbook()
    // 2.创建表格，第二个参数可以配置创建什么样的工作表
    if (Object.prototype.toString.call(luckysheetData) === '[object Object]') {
      luckysheetData = [luckysheetData]
    }
    luckysheetData.forEach(function(table) {
      if (table.data.length === 0) return  true
      // ws.getCell('B2').fill = fills.
      const worksheet = workbook.addWorksheet(table.name, {properties:{defaultColWidth :20}})
      // const merge = (table.config && table.config.merge) || {}
      const borderInfo = (table.config && table.config.borderInfo) || {}
      // 3.设置单元格合并,设置单元格边框,设置单元格样式,设置值
      setStyleAndValue(table.data, worksheet)
      // setMerge(merge, worksheet) 暂时去掉这个合并单元格
      setBorder(borderInfo, worksheet)
      return true
    })
    workbook.xlsx.writeBuffer().then(data => {
      if (isDown) {
        // 下载文件
        const blob = new Blob([data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        FileSaver.saveAs(blob, `${fileName}.xlsx`)
      } else {
        // 从buffer读取xlsx文件
        const wb = XLSX.read(data, { type: 'buffer' });
        // 将工作簿（workbook）写入到一个新的xls文件
        const xlsBuffer = XLSX.write(wb, { bookType: 'xls', type: 'buffer' });
        const blob = new Blob([xlsBuffer], {
          type: 'application/vnd.ms-excel'
        })
        // FileSaver.saveAs(blob, `${fileName}.xls`)
        // 上传文件
        setTimeout(async () => {
          const file = new File([blob], `${fileName}.xls`);
          const formData = new FormData();
          const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
          formData.append('file', file);
          const url = '/userfile/upload?accesstoken='+token
          const config = {
            headers: {
              'Content-Type':'multipart/form-data',
            }
          }
          const { data } = await axios.post(url, formData, config ).catch(err => { console.log(err) })
          resolve(data)
        }, 100)
      }
    })
  })
}

export const submitVerify = async (obj = {}) => {
  errorNum = 0
  const { _colConfg = {}, isSecond = false, requiredFieldCol = [], importType, dataOptionsData = {} } = obj
  let { luckysheetData } = obj
  const colConfg = {}
  for(const key in _colConfg) {
    const item = _colConfg[key]
    colConfg[item.col] = item
  }
  if (Object.prototype.toString.call(luckysheetData) === '[object Object]') {
    luckysheetData = [luckysheetData]
  }
  const userData = {}
  luckysheetData.forEach( (table) => {
    const headRow = isSecond ? 1 : 0

    table.data.forEach((row, rowIndex) => {
      if (rowIndex > headRow) {
        const isRowData = row.findIndex(item => { return item && (item.v || item.v === 0) })
        // 整行没数据就过滤掉
        if (isRowData !== -1) {
          row.forEach((col, colIndex) => {
            if (col) {
              const cellConfig = colConfg[colIndex]
              const cellValue = col.v
              // 存在表单配置
              if (cellConfig) {
                // 存在值
                if (cellValue || cellValue === 0 ) {
                  if (cellConfig.type === 'relation-user') {
                    if (userData[colIndex] === undefined) {
                      userData[colIndex] = []
                    }
                    if (!userData[colIndex].includes(cellValue) && !cellValue.includes('(')) {
                      // 带括号的说明是加了userId的 就不用去查询了
                      let val = cellValue.split(',')
                      // 联系人去重
                      if (new Set(val).size !== val.length) {
                        val = Array.from(new Set(val))
                        editCellValue(rowIndex, colIndex, val.join())
                      }
                      userData[colIndex].push(...val)
                    }
                  } else if (cellConfig.type === 'number') {
                    if (isNaN(cellValue)) {
                      verifyErrorSet(rowIndex, colIndex, '填入的值不是数字格式', '#FF0000')
                    }
                  } else if (cellConfig.type === 'date') {
                    // 日期要用显示值去匹配
                    const isTime = isTimeFormat(col.m)
                    const isDate = !isNaN(Date.parse(col.m))
                    // 两种格式都不对就抛出这个问题
                    if (!isDate && !isTime) {
                      verifyErrorSet(rowIndex, colIndex, '填入的值不是日期格式', '#FF0000')
                    }
                  } else if (cellConfig.type === 'radio' || cellConfig.type === 'checkbox') {
                    const dataconfig = cellConfig.dataconfig
                    let sels = []
                    // 有个选项联动的
                    if (dataconfig && dataconfig.setUpValue === 3) {
                      sels = dataOptionsData[`${cellConfig.title}_${cellConfig.type}`] || []
                    } else {
                      sels = Array.isArray(cellConfig.sels) ? cellConfig.sels.map(item => { return item.value || item}) : JSON.parse(cellConfig.sels)
                      sels = sels.map(item => { return typeof item === 'string' ? item.trim() : item })
                    }
                    if (sels.length > 0) {
                      const strValue = typeof cellValue === 'number' ? cellValue.toString() : cellValue
                      strValue.split(',').forEach(val => {
                        if (!sels.includes(val)) {
                          verifyErrorSet(rowIndex, colIndex, val + '不存在下拉选项中', '#FF0000')
                        }
                      })
                    }
                  }
                } else {
                  if (requiredFieldCol.includes(colIndex)) {
                    verifyErrorSet(rowIndex, colIndex, '必填项未填', '#FF0000')
                  }
                }
              } else {
                if (importType === 0 && colIndex === 0 && cellValue) {
                  if (userData[colIndex] === undefined) {
                    userData[colIndex] = []
                  }
                  // 发起人
                  if (!userData[colIndex].includes(cellValue) && !cellValue.includes('(')) {
                    // 带括号的说明是加了userId的 就不用去查询了
                    userData[colIndex].push(cellValue)
                  }
                }
              }
            } else {
              if (requiredFieldCol.includes(colIndex)) {
                verifyErrorSet(rowIndex, colIndex, '必填项未填', '#FF0000')
              }
            }
          })
        }
      }
    })
  })
  if (Object.keys(userData).length > 0) {
    await userVerify(userData, colConfg, importType)
  }
  return errorNum
}

const isTimeFormat = (timeStr) => {
  // 匹配ISO 8601格式的时间字符串
  const regex = /^[0-9]{2}:[0-5][0-9]$/;
  return regex.test(timeStr);
}

// 联系人控件的验证
const userVerify = async (userData, colConfg, importType) => {
  let organizations, roles
  for(const col in userData) {
    if (userData[col].length === 0) continue
    const query = { name: userData[col] }
    const colConfgData = colConfg[col]
    if (colConfgData) {
      //部门查看范围。1:本部门不含子部门,2:本部门及其子部门,3:全部部门,4:自定义,5是无
      switch (colConfgData.lookRMSIsUser) {
        case 1:{
          query.organizationIdss = organizations
          break;
        }
        case 2:{
          query.organizationIdss = organizations
          break;
        }
        case 4:{
          if (colConfgData.lookCustomArr.length > 0) {
            const arr = JSON.parse(colConfgData.lookCustomArr).map(item=>{
              return item.organizationId
            })
            query.organizationsId = arr.toString()
          }
          break;
        }
      }
      //角色查看范围。1:所在角色,2:全部角色,3:自定义,4:无
      switch (colConfgData.lookRMSIsUserRole) {
        case 1:{
          query.roleIds = roles
          break;
        }
        case 3:{
          if (colConfgData.lookCustomArrRole.length > 0) {
            const arr = JSON.parse(colConfgData.lookCustomArrRole).map(item=>{
              return item.roleId
            })
            query.roleIds = arr.toString()
          }
        }
      }
    }
    // 判断是否组织空间
    const hasSpaceQuery = typeof window !== 'undefined' && window.location && new URLSearchParams(window.location.search).has('space')
    if (hasSpaceQuery) {
      query.organizationsId = localStorage.getItem('spaceid')
    }
    const { code, data } = await axiosBase(query, '/api/getuserbyname')
    if (code === 0) {
      for (const key in data) {
        const item = data[key]
        const len = item.length
        // 联系人不存在
        if (len === 0) {
          const errorCell = luckysheet.find(key)

          errorCell.forEach(iten => {
            // 只有值和联系人控件才要替换
            if ((importType === 0 || (iten.column == col && colConfg[iten.column].type === 'relation-user')) && iten.v === key) {
              verifyErrorSet(iten.row, iten.column, key + '找不到', '#FF0000')
            }
          })
        } else if (len > 1) {
          // 联系人存在同名
          const errorCell = luckysheet.find(key)
          errorCell.forEach(iten => {
            // 只有值和联系人控件才要替换 全部数据的话发起人也要替换
            if ((iten.column == col && colConfg[iten.column] && colConfg[iten.column].type === 'relation-user') || (importType === 0 && iten.column === 0)) {
              if (iten.v === key) {
                verifyErrorSet(iten.row, iten.column, key + '存在同名请选择', '#0066CC')
                // 设置选项验证范围
                const range = { row:[iten.row, iten.row], column:[iten.column, iten.column] }
                const sels = item.map(iten => { return `${iten.realname}(${iten.username})` })
                const dataVerification = {
                  type: 'dropdown',
                  value1: sels.join(','),
                  prohibitInput: true
                }
                luckysheet.setDataVerification(dataVerification, { range })
              }
            }
          })
        }
      }
    }
  }

}

// 错误值的提示设置
const verifyErrorSet = (rowIndex, colIndex, val, color) => {
  errorNum += 1
  luckysheet.setCellValue(rowIndex, colIndex, val)
  setTimeout(() => {
    luckysheet.setCellFormat(rowIndex, colIndex, 'bg', color)
  }, 100)
}

// 重复值去重
const editCellValue = (rowIndex, colIndex, val) => {
  luckysheet.setCellValue(rowIndex, colIndex, val)
}

// const setMerge = function(luckyMerge = {}, worksheet) {
//   const mergearr = Object.values(luckyMerge)
//   mergearr.forEach(function(elem) {
//     // elem格式：{r: 0, c: 0, rs: 1, cs: 2}
//     // 按开始行，开始列，结束行，结束列合并（相当于 K10:M12）
//     worksheet.mergeCells(
//       elem.r + 1,
//       elem.c + 1,
//       elem.r + elem.rs,
//       elem.c + elem.cs
//     )
//   })
// }

const setBorder = function(luckyBorderInfo, worksheet) {
  if (!Array.isArray(luckyBorderInfo)) return
  luckyBorderInfo.forEach(function(elem) {
    // 现在只兼容到borderType 为range的情况
    if (elem.rangeType === 'range') {
      let border = borderConvert(elem.borderType, elem.style, elem.color)
      let rang = elem.range[0]
      let row = rang.row
      let column = rang.column
      for (let i = row[0] + 1; i < row[1] + 2; i++) {
        for (let y = column[0] + 1; y < column[1] + 2; y++) {
          worksheet.getCell(i, y).border = border
        }
      }
    }
    if (elem.rangeType === 'cell') {
      // col_index: 2
      // row_index: 1
      // b: {
      //   color: '#d0d4e3'
      //   style: 1
      // }
      const { col_index, row_index } = elem.value
      const borderData = Object.assign({}, elem.value)
      delete borderData.col_index
      delete borderData.row_index
      let border = addborderToCell(borderData, row_index, col_index)
      worksheet.getCell(row_index + 1, col_index + 1).border = border
    }
    // worksheet.getCell(rang.row_focus + 1, rang.column_focus + 1).border = border
  })
}

const setStyleAndValue = function(cellArr, worksheet) {
  if (!Array.isArray(cellArr)) return
  cellArr.forEach(function(row, rowid) {
    row.every(function(cell, columnid) {
      if (!cell) return true
      let fill = fillConvert(cell.bg)

      let font = fontConvert(
        cell.ff,
        cell.fc,
        cell.bl,
        cell.it,
        cell.fs,
        cell.cl,
        cell.ul
      )
      let alignment = alignmentConvert(cell.vt, cell.ht, cell.tb, cell.tr)
      let value = ''

      if (cell.f) {
        value = { formula: cell.f, result: cell.v }
      } else if (!cell.v && cell.ct && cell.ct.s) {
        // xls转为xlsx之后，内部存在不同的格式，都会进到富文本里，即值不存在与cell.v，而是存在于cell.ct.s之后
        // value = cell.ct.s[0].v
        cell.ct.s.forEach(arr => {
          value += arr.v
        })
      } else if (cell.v && cell.ct && cell.ct.fa) {
        // 针对日期格式做处理
        if (dateFormat.includes(cell.ct.fa)) {
          value = cell.m
        } else {
          value = cell.v
        } 
      } else {
        value = cell.v
      }
      //  style 填入到_value中可以实现填充色
      let letter = createCellPos(columnid)
      let target = worksheet.getCell(letter + (rowid + 1))
      for (const key in fill) {
        target.fill = fill[key]
        break
      }
      target.font = font
      target.alignment = alignment
      target.value = value

      return true
    })
  })
}

const fillConvert = function(bg) {
  if (!bg) {
    return {}
  }
  // const bgc = bg.replace('#', '')
  let fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: bg.replace('#', '') }
  }
  return fill
}

const fontConvert = function(
    ff = 0,
    fc = '#000000',
    bl = 0,
    it = 0,
    fs = 10,
    cl = 0,
    ul = 0
  ) {
  // luckysheet：ff(样式), fc(颜色), bl(粗体), it(斜体), fs(大小), cl(删除线), ul(下划线)
  const luckyToExcel = {
    0: '微软雅黑',
    1: '宋体（Song）',
    2: '黑体（ST Heiti）',
    3: '楷体（ST Kaiti）',
    4: '仿宋（ST FangSong）',
    5: '新宋体（ST Song）',
    6: '华文新魏',
    7: '华文行楷',
    8: '华文隶书',
    9: 'Arial',
    10: 'Times New Roman ',
    11: 'Tahoma ',
    12: 'Verdana',
    num2bl: function(num) {
      return num === 0 ? false : true
    }
  }
  // 出现Bug，导入的时候ff为luckyToExcel的val

  let font = {
    name: typeof ff === 'number' ? luckyToExcel[ff] : ff,
    family: 1,
    size: fs,
    color: { argb: fc.replace('#', '') },
    bold: luckyToExcel.num2bl(bl),
    italic: luckyToExcel.num2bl(it),
    underline: luckyToExcel.num2bl(ul),
    strike: luckyToExcel.num2bl(cl)
  }

  return font
}

const alignmentConvert = function(
    vt = 'default',
    ht = 'default',
    tb = 'default',
    tr = 'default'
  ) {
  // luckysheet:vt(垂直), ht(水平), tb(换行), tr(旋转)
  const luckyToExcel = {
    vertical: {
      0: 'middle',
      1: 'top',
      2: 'bottom',
      default: 'top'
    },
    horizontal: {
      0: 'center',
      1: 'left',
      2: 'right',
      default: 'left'
    },
    wrapText: {
      0: false,
      1: false,
      2: true,
      default: false
    },
    textRotation: {
      0: 0,
      1: 45,
      2: -45,
      3: 'vertical',
      4: 90,
      5: -90,
      default: 0
    }
  }

  let alignment = {
    vertical: luckyToExcel.vertical[vt],
    horizontal: luckyToExcel.horizontal[ht],
    wrapText: luckyToExcel.wrapText[tb],
    textRotation: luckyToExcel.textRotation[tr]
  }
  return alignment
}

const borderConvert = function(borderType, style = 1, color = '#000') {
  // 对应luckysheet的config中borderinfo的的参数
  if (!borderType) {
    return {}
  }
  const luckyToExcel = {
    type: {
      'border-all': 'all',
      'border-top': 'top',
      'border-right': 'right',
      'border-bottom': 'bottom',
      'border-left': 'left'
    },
    style: {
      0: 'none',
      1: 'thin',
      2: 'hair',
      3: 'dotted',
      4: 'dashDot', // 'Dashed',
      5: 'dashDot',
      6: 'dashDotDot',
      7: 'double',
      8: 'medium',
      9: 'mediumDashed',
      10: 'mediumDashDot',
      11: 'mediumDashDotDot',
      12: 'slantDashDot',
      13: 'thick'
    }
  }
  let template = {
    style: luckyToExcel.style[style],
    color: { argb: color.replace('#', '') }
  }
  let border = {}
  if (luckyToExcel.type[borderType] === 'all') {
    border['top'] = template
    border['right'] = template
    border['bottom'] = template
    border['left'] = template
  } else {
    border[luckyToExcel.type[borderType]] = template
  }
  return border
}

function addborderToCell(borders) {
  let border = {}
  const luckyExcel = {
    type: {
      l: 'left',
      r: 'right',
      b: 'bottom',
      t: 'top'
    },
    style: {
      0: 'none',
      1: 'thin',
      2: 'hair',
      3: 'dotted',
      4: 'dashDot', // 'Dashed',
      5: 'dashDot',
      6: 'dashDotDot',
      7: 'double',
      8: 'medium',
      9: 'mediumDashed',
      10: 'mediumDashDot',
      11: 'mediumDashDotDot',
      12: 'slantDashDot',
      13: 'thick'
    }
  }
  for (const bor in borders) {
    if (borders[bor]) {
      if (borders[bor].color.indexOf('rgb') === -1) {
        border[luckyExcel.type[bor]] = {
          style: luckyExcel.style[borders[bor].style],
          color: { argb: borders[bor].color.replace('#', '') }
        }
      } else {
        border[luckyExcel.type[bor]] = {
          style: luckyExcel.style[borders[bor].style],
          color: { argb: borders[bor].color }
        }
      }
    }
  }

  return border
}

function createCellPos(n) {
  let ordA = 'A'.charCodeAt(0)

  let ordZ = 'Z'.charCodeAt(0)
  let len = ordZ - ordA + 1
  let s = ''
  while (n >= 0) {
    s = String.fromCharCode((n % len) + ordA) + s

    n = Math.floor(n / len) - 1
  }
  return s
}
